import {useQueryClient} from '@tanstack/react-query';
import {createApiQuery, useApiMutation} from '../../hooks/api/api';
import {CancelTask, GetTasks} from '../../shared/api/definitions/debug';

export const taskKeys = {
  all: ['tasks'],
  list: (search?: string) => [...taskKeys.all, {search}],
} as const;

export const useGetTasks = createApiQuery(GetTasks, ({partialCustomerName}) =>
  taskKeys.list(partialCustomerName)
);

export const useCancelTask = () => {
  const queryClient = useQueryClient();

  return useApiMutation(CancelTask, {
    onSuccess: async () => {
      // Refetch list of tasks
      await queryClient.invalidateQueries({
        queryKey: taskKeys.all,
      });
    },
  });
};
